import { useCallback } from 'react';
import { useGetUserProfileQuery } from '@/store/api';
/**
 * Platform-services hook for fetching the current user's profile.
 *
 * Wraps the RTK Query `useGetUserProfileQuery` hook. Containers and hooks
 * should use this instead of importing from `@/store/api` directly.
 *
 * @returns Consistent query result shape with data, loading, error, and refetch.
 *
 * @see src/store/api/cc/userProfileApi.ts
 */
export const useGetUserProfile = () => {
    const { data, isLoading, isError, error, refetch, isFetching, } = useGetUserProfileQuery();
    const refetchProfile = useCallback(() => refetch().unwrap(), [refetch]);
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        refetchProfile,
    };
};
